module.exports = __webpack_public_path__ + "img/zap.610c57ea.svg";